<template>
	<div class="Order">
		<div class="order-nav">
			<van-nav-bar :fixed="true">
				<template #left>
					<div class="left-text">
						<div class="logo"><img class="auto-img" src="../assets/images/coffee_icon.jpg" alt=""></div>
						<div class="logo-title">Luckin Coffee</div>
					</div>
				</template>
				<template #right>
					<div class="right-text" @click="back">
						返回
					</div>
				</template>
			</van-nav-bar>
		</div>

		<div class="address-box">
			<div class="address">
				<div class="clearfix">
					<div class="fl address-title" @click="openAddressBox">选择收货地址</div>
					<van-popup v-model="isOpen" position="bottom">
						<div class="address-title-inside">选择收货地址</div>
						<van-address-list v-model="chosenAddressId" :list="list" default-tag-text="默认" @add="goNewAddress" @select="selectAddress" />
					</van-popup>
					<div class="fl allow-box" @click="openAddressBox">
						<van-icon name="arrow" />
					</div>
				</div>
				<div class="address-inf">
					<div class="clearfix order-info">
						<div class="fl name">{{currentAddress.name}}</div>
						<div class="fl phone">{{currentAddress.tel}}</div>
					</div>
					<div class="address-msg">{{currentAddress.address}}</div>
				</div>
			</div>
		</div>


		<div class="order-inf">
			<div class="order-box">
				<div class="order-title">订单信息</div>
				<div>
					<div class="bag-product" v-for="(item,index) in shopbagData" :key="index">
						<van-swipe-cell>
							<van-cell :border="false">
								<div class="clearfix">
									<div class="fl pro-img">
										<img class="auto-img" :src="item.small_img" alt="">
									</div>
									<div class="fl pro-info">
										<div class="text-box">
											<div class="clearfix nameAndRule">
												<div class="fl text-name">{{item.name}}</div>
												<div class="fl text-rule">{{item.rule}}</div>
											</div>
											<div class="text-enname">{{item.enname}}</div>
										</div>
										<div class="price-box clearfix">
											<div class="price fl">￥{{item.price}}</div>
											<div class="count fr">
												x{{item.count}}
											</div>
										</div>
									</div>
								</div>
							</van-cell>
						</van-swipe-cell>
					</div>

					<div class="order-price">
						<div class="clearfix order-price-box">
							<div class="fl pro-count">共计{{product.count}}件商品</div>
							<div class="fr pro-total">合计￥{{product.total}}</div>
						</div>
					</div>



				</div>
			</div>
			<div class="pay-button">
				<van-submit-bar @submit="pay" button-text="立即结算"></van-submit-bar>
			</div>
		</div>


	</div>
</template>

<script>
	import '../assets/less/order.less';
	import {
		utils
	} from '../assets/js/utils.js'
	import {
		Toast
	} from 'vant';

	export default {
		data() {
			return {
				isOpen: false,
				chosenAddressId: '',
				list: [],

				// 购物袋数据
				shopbagData: [],

				// 选择地址数据
				currentAddress: {
					name: '',
					tel: '',
					address: ''
				},

				product: {
					count: 0,
					total: 0,
				},

				sids: []
			};
		},

		created() {
			this.sids = this.$route.query.sids.split('-');

			this.getReceiveAddress();
			this.getShopbagDataBySids();
		},

		methods: {
			openAddressBox() {
				this.isOpen = true;
			},

			//返回上一级
			back() {
				this.$router.go(-1);
			},

			//选择地址
			selectAddress(item, index) {
				for (let key in this.currentAddress) {
					this.currentAddress[key] = item[key];
				}
			},

			//跳转新增地址
			goNewAddress() {
				this.$router.push({
					name: 'NewAddress'
				});
			},

			//查询收货地址
			getReceiveAddress() {
				//获取token
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					return;
				}

				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'GET',
					url: '/findAddress',
					params: {
						appkey: this.appkey,
						tokenString
					}
				}).then(result => {
					this.$toast.clear();
					if (result.data.code == 20000) {

						result.data.result.map(v => {
							let address = v.province + v.city + v.county + v.addressDetail;
							this.list.push({
								id: v.aid,
								name: v.name,
								tel: v.tel,
								address,
								isDefault: Boolean(v.isDefault)
							})

							if (Boolean(v.isDefault)) {
								this.chosenAddressId = v.aid,
									this.currentAddress.name = v.name;
								this.currentAddress.tel = v.tel;
								this.currentAddress.address = address;
							}
						})
					}

				}).catch(err => {
					this.$toast.clear();
				})
			},

			//根据sids查询购物袋数据
			getShopbagDataBySids() {
				//获取token
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					return;
				}

				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'GET',
					url: '/commitShopcart',
					params: {
						appkey: this.appkey,
						tokenString,
						sids: JSON.stringify(this.sids)
					}
				}).then(result => {
					this.$toast.clear();
					if (result.data.code == 50000) {
						if (result.data.result.length === 0) {
							this.$router.push({
								name: 'Menu'
							})
						}

						result.data.result.map(v => {
							this.product.count += v.count;
							this.product.total += v.count * v.price;
						})

						this.shopbagData = result.data.result;

					}

				}).catch(err => {
					this.$toast.clear();
				})
			},

			//立刻支付
			pay() {
				//判断是否选择地址
				if (this.chosenAddressId == '') {
					this.$toast('请选择收货地址');
					return;
				}

				//获取token
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					return;
				}

				// 参数序列化

				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					sids: JSON.stringify(this.sids),
					phone: this.currentAddress.tel,
					address: this.currentAddress.address,
					receiver: this.currentAddress.name
				})

				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'POST',
					url: '/pay',
					data
				}).then(result => {
						this.$toast.clear();
						this.$toast(result.data.msg);
					if (result.data.code == 60000) {
						this.$router.push({name: 'CheckOrder'})
					}

				}).catch(err => {
				this.$toast.clear();
			})

			}
		}
	}
</script>
